
































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { MSResponse } from '@/interfaces/MS';
import FlotasMap from '@/pantallas/TorreControl/ControlFlotas/FlotasMap.vue';
import FlotasCarousel from '@/pantallas/TorreControl/ControlFlotas/FlotasCarousel.vue';
import Datatables from '@/pantallas/TorreControl/Datatables.vue';
import { FlotaService } from '@/pantallas/TorreControl/ControlFlotas/flotaService';
import { ControlFlotasInterface } from '@/pantallas/TorreControl/ControlFlotas/controlFlotasInterface';
import { headers } from '@/pantallas/TorreControl/ControlFlotas/controlFlotasHeaders';
import { AxiosResponse } from 'axios';
import { ClientFilterI } from '@/interfaces/Filters';
import TorreControlInstance from '@/pantallas/TorreControl/comunes/Instances';
import searchSimple from '@/pantallas/TorreControl/searchSimple.vue';

@Component({
  name: 'ControlFlotas',
  components: {
    FlotasCarousel,
    Datatables,
    FlotasMap,
    searchSimple,
  },
})
export default class ControlFlotas extends ComponenteBase {
  accionesTotales: PermisoAccion[];
  loadingService = new LoadingService();
  tabSelected: any = 0;
  flotaService = new FlotaService();
  clientId: string;
  isLoading: boolean = false;
  readonly funcionalidad: Funcionalidades = Funcionalidades.TorreControl;
  dataTable: ControlFlotasInterface[] = [];
  dataTable2: ControlFlotasInterface[] = [];
  headers = headers;
  client: ClientFilterI = { id: '', nombre: '', rut: '' };
  patente: string = '';
  vehiculoSelected: any = {};
  showInfoDialog: boolean = false;
  intervalo: any;

  clientData: any = null;

  constructor() {
    super();
    this.getClientId();
  }

  beforeDestroy() {
    TorreControlInstance.$off('changeSlide');
    TorreControlInstance.$off('vehiculoSelected');
  }

  mounted() {
    let self = this;
    this.getFlota(false).finally(() => {
      self.loadingService.hideLoading();
    });
    TorreControlInstance.$on('changeSlide', () => {
      this.clearFilters();
    });
    TorreControlInstance.$on('vehiculoSelected', (selection: any) => {
      this.vehiculoSelected = selection;
      this.showInfoDialog = true;
    });
  }

  async getFlota(sumary: boolean) {
    let self = this;
    this.dataTable = [];
    this.isLoading = true;
    this.loadingService.showLoading();
    const axiosResponse: AxiosResponse<
      MSResponse<any>
    > = await this.flotaService.getFlotas(this.clientId, sumary);
    this.isLoading = false;
    const msRespose: any = axiosResponse.data;
    if (msRespose.CODIGO_RESPUESTA === '1') {
      this.clientData = msRespose.clientData;
      // console.log(this.clientData)
      // console.log(msRespose.data)
      if (this.clientData != null) {
        if (this.clientData.active_custom && this.tabSelected == 0) {
          for (let custom in this.clientData.dataCustom) {
            let item = {
              cod_flota: custom,
              __nom_flota: custom,
              total_vehiculos: 0,
              transm_today: 0,
              transm_percent: 0,
              nt_week: 0,
              nt_week_percent: 0,
              nt_month: 0,
              nt_month_percent: 0,
              nt_plusmonth: 0,
              nt_plusmonth_percent: 0,
              nt_never: 0,
              nt_never_percent: 0,
              uri: '',
            };
            this.dataTable.push(item);
          }
          msRespose.data.forEach((item: ControlFlotasInterface) => {
            if (self.dataTable2.length == 0) {
              self.dataTable2.push(item);
            } else {
              if (
                !self.dataTable2.find(obj => obj.cod_flota === item.cod_flota)
              )
                self.dataTable2.push(item);
            }
          });
        } else {
          msRespose.data.forEach((item: ControlFlotasInterface) => {
            if (self.dataTable.length == 0) {
              self.dataTable.push(item);
            } else {
              if (!self.dataTable.find(obj => obj.cod_flota === item.cod_flota))
                self.dataTable.push(item);
            }
          });
          TorreControlInstance.$emit('dataTable', this.dataTable);
        }
      } else {
        msRespose.data.forEach((item: ControlFlotasInterface) => {
          if (self.dataTable.length == 0) {
            self.dataTable.push(item);
          } else {
            if (!self.dataTable.find(obj => obj.cod_flota === item.cod_flota))
              self.dataTable.push(item);
          }
        });
        TorreControlInstance.$emit('dataTable', this.dataTable);
      }
    } else {
      this.dataTable = [];
    }
    // this.loadingService.hideLoading();
  }

  onInputFilter() {
    clearInterval(this.intervalo);
    const self = this;
    this.intervalo = setInterval(function() {
      if (self.patente.length >= 3) {
        TorreControlInstance.$emit('searchPatente', self.patente, true);
      } else if (self.patente.length < 3) {
        TorreControlInstance.$emit('searchPatente', self.patente, true);
      }
      clearInterval(self.intervalo);
    }, 500);
  }

  getClientId() {
    this.clientId = localStorage.getItem('clienteDefecto');
  }

  selectMap() {
    let self = this;
    this.tabSelected = 0;
    this.getFlota(false).finally(() => {
      self.loadingService.hideLoading();
    });
  }

  selectDatatable() {
    let self = this;
    this.tabSelected = 1;
    this.getFlota(true).finally(() => {
      self.loadingService.hideLoading();
    });
  }

  clearFilters(flag = true) {
    this.client = { id: '', nombre: '', rut: '' };
    this.patente = '';
    if (!flag) {
      this.onInputFilter();
    } else {
      TorreControlInstance.$emit('searchPatente', this.patente, false);
    }
  }

  onChangeFilter() {
    TorreControlInstance.$emit('searchPatente', this.patente, false);
  }

  goPatente(uri: string) {
    if (uri) {
      this.$router.push(uri);
    } else {
      this.$snotify.warning('Vehículo sin Patente');
    }
  }

  onBtnExport() {
    TorreControlInstance.$emit('exportFlota');
  }
}
